import React from 'react';

import clsx from 'clsx';

import * as classes from './Block.module.css';

const Constant = ({
    innerEditor,
    id,
    ...props
}) => {

    return (
        <span style={{ display: 'flex', alignItems: 'center' }} id={`${id}-block-constant`}>
            <React.Fragment>&nbsp;</React.Fragment>
            <div data-id={id} id={`${id}-block-constant`} className={classes.Block}>
                <input
                    id={`${id}-input-value`}
                    type="number"
                    className="MuiInputBase-input formula-textbox"
                />
                <span
                    id={`${id}-delete`}
                    role="none"
                    className={clsx('material-icons-outlined', classes.DeleteIcon)}
                >
                    delete
                </span>
            </div>
            <React.Fragment>&nbsp;</React.Fragment>
        </span>
    );
};

export default Constant;
